(() => {
  const PEEK_SLIDES_PER_VIEW = 1.15;
  const SIDECART_SELECTOR = '[data-helloretail-sidecart-products] .swiper-container';
  const MARK_ATTR = 'data-peek-applied';

  const applyPeek = (container) => {
    if (!container || !container.swiper) return false;
    if (container.getAttribute(MARK_ATTR) === '1') return true;
    const swiper = container.swiper;
    swiper.params.slidesPerView = PEEK_SLIDES_PER_VIEW;
    if (swiper.params.breakpoints) {
      Object.keys(swiper.params.breakpoints).forEach((bp) => {
        swiper.params.breakpoints[bp].slidesPerView = PEEK_SLIDES_PER_VIEW;
      });
    }
    swiper.update();
    container.setAttribute(MARK_ATTR, '1');
    return true;
  };

  const scan = () => {
    document.querySelectorAll(SIDECART_SELECTOR).forEach(applyPeek);
  };

  scan();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;
      if (mutation.addedNodes.length === 0) continue;
      scan();
      break;
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
